import * as React from 'react'
import styles from './error.module.scss'
import { FormattedHTMLMessage, FormattedMessage, MessageDescriptor } from 'react-intl'

interface IErrorProps {
  center?: boolean
  value?: MessageDescriptor
  children?: React.ReactNode
  html?: boolean
}

export default function Error({ center, value, children, html }: IErrorProps) {
  return (
    <p className={styles.error} style={{ textAlign: center ? 'center' : 'left' }}>
      {children || (value ? html ? <FormattedHTMLMessage {...value} /> : <FormattedMessage {...value} /> : null)}
    </p>
  )
}
